import { EventAnalyticsRevenueSummaryDto } from 'legacy/events/types';

import { useQuery } from 'react-query';
import { ErrorResponse } from 'legacy/common/utils/error';
import { getEventAnalyticsRevenueSummary } from '../service';

export function useEventAnalyticsRevenueSummary({
  eventId
}: {
  eventId: string;
}) {
  return useQuery<EventAnalyticsRevenueSummaryDto, ErrorResponse>(
    ['data', { eventId }],
    () => getEventAnalyticsRevenueSummary({ eventId })
  );
}
